import { Box } from '@material-ui/core';
import { Comment } from '@nemuru-eng/js-api-client';
import React from 'react';

import { useCustomTheme } from '../../../../../../../../hooks/useCustomTheme';
import { getCommentChannelIcon } from '../../../../../utils/getCommentChannelIcon';

interface CommentChannelIconProps {
  comment: Comment;
}
export const CommentChannelIcon = ({ comment }: CommentChannelIconProps) => {
  const { palette, customBorderRadius } = useCustomTheme();

  return (
    <Box
      display={'flex'}
      alignItems={'center'}
      justifyContent={'center'}
      borderRadius={customBorderRadius.paper}
      bgcolor={palette.grey[200]}
      height={'36px'}
      width={'36px'}
    >
      <i className={'material-icons-outlined'} style={{ fontSize: '20px' }}>
        {getCommentChannelIcon(comment.channel)}
      </i>
    </Box>
  );
};
